import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import COLOURS from "util/colours";
import ProfileMainCard from "visual-components/util/profile-main-card";
import CardHeaderItem from "./card-header-item";
import LegendItem from "./legend-item";

/**
 * Income Card Component
 * Displays income distribution as a pie chart
 * @param {Object} props
 * @param {Object} props.distribution - Income distribution data
 * @returns {import("react").ReactElement}
 */
export default function IncomeCard(props) {
  const { distribution } = props;

  const pieData = [
    { id: 0, value: distribution.over100 || 0, label: "100K +", color: COLOURS.blues.one },
    { id: 1, value: distribution.sub99 || 0, label: "75-99k", color: COLOURS.blues.two },
    { id: 2, value: distribution.sub74 || 0, label: "50-74k", color: COLOURS.blues.three },
    { id: 3, value: distribution.sub49 || 0, label: "35-49k", color: COLOURS.blues.four },
    { id: 4, value: distribution.sub30 || 0, label: "<35k", color: COLOURS.blues.five },
  ];

  const total = pieData.reduce((sum, item) => sum + item.value, 0);

  return (
    <Box sx={{ position: "relative", width: 460 }}>
      <ProfileMainCard title="Income">
        <Box sx={{ display: "inline-block", width: 280 }}>
          <CardHeaderItem label="ANNUAL HOUSEHOLD INCOME ($)" />
          <LegendItem label="< 35K" color={COLOURS.blues.five} />
          <LegendItem label="75-99K" color={COLOURS.blues.two} />
          <LegendItem label="35-49K" color={COLOURS.blues.four} />
          <LegendItem label="100K +" color={COLOURS.blues.one} />
          <LegendItem label="50-74k" color={COLOURS.blues.three} />
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: 25,
            right: -25,
            width: 290,
            height: 290,
          }}
        >
          <PieChart
            series={[
              {
                data: pieData,
                innerRadius: 0,
                outerRadius: 100,
                paddingAngle: 0,
                cornerRadius: 0,
                valueFormatter: (item) => {
                  const percent = total > 0 ? ((item.value / total) * 100).toFixed(0) : 0;
                  return `${item.label}: ${percent}%`;
                },
              },
            ]}
            width={290}
            height={290}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            hideLegend
          />
        </Box>
      </ProfileMainCard>
    </Box>
  );
}

IncomeCard.propTypes = {
  distribution: PropTypes.object.isRequired,
};
